import RulesContent from '../components/websiteComponents/RulesContent';

const Rules = () => {
  return <RulesContent />;
};

export default Rules;
